import { withInstall } from '@lit-element/utils'
import Affix from './src/affix.vue'
import type { SFCWithInstall } from '@lit-element/utils'
export const LtAffix: SFCWithInstall<typeof Affix> = withInstall(Affix)
export default LtAffix

export * from './src/affix'
